/**
 * single-select-facets.js
 * Forces specific Shopify facet filters (rendered as checkboxes) to behave like radio groups
 * by allowing only one checked value per targeted filter.
 *
 * Targets filter headings:
 * - "Akun kapasiteetti"
 * - "Moottorin vääntö"
 */

(() => {
  const TARGET_LABELS = ['Akun kapasiteetti', 'Moottorin vääntö'];

  const normalize = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  // Try to read the visible filter heading text robustly across themes
  function getHeadingTextFromFilterContainer(container) {
    if (!container) return '';

    // Common candidates in different themes
    const candidates = [
      container.querySelector('summary'),
      container.querySelector('.filter__toggle'),
      container.querySelector('.facets__label'),
      container.querySelector('.disclosure__toggle'),
      container.querySelector('[data-filter-label]'),
      container.querySelector('legend'),
      container.querySelector('h3'),
      container.querySelector('h4'),
      container.querySelector('button'),
    ].filter(Boolean);

    let text = '';
    for (const el of candidates) {
      // data-filter-label sometimes exists
      const dataLabel = el.getAttribute && el.getAttribute('data-filter-label');
      if (dataLabel && dataLabel.trim()) {
        text = dataLabel;
        break;
      }
      if (el.textContent && el.textContent.trim()) {
        text = el.textContent;
        break;
      }
    }
    return normalize(text);
  }

  function isTargetFilterContainer(container) {
    const heading = getHeadingTextFromFilterContainer(container);
    return TARGET_LABELS.some((t) => heading.includes(normalize(t)));
  }

  function findFilterContainerForInput(input) {
    // Most themes wrap each filter in details.filter / details.disclosure
    return (
      input.closest('details.filter') ||
      input.closest('details.disclosure') ||
      input.closest('[data-filter]') ||
      input.closest('.filter') ||
      input.closest('.disclosure')
    );
  }

  function enforceSingleSelect(changedCheckbox) {
    const container = findFilterContainerForInput(changedCheckbox);
    if (!container) return;
    if (!isTargetFilterContainer(container)) return;

    const checkboxes = container.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((cb) => {
      if (cb !== changedCheckbox) cb.checked = false;
    });
  }

  // Capture-phase: uncheck others before theme's facet JS reads state
  document.addEventListener(
    'change',
    (e) => {
      const el = e.target;
      if (!(el instanceof HTMLInputElement)) return;
      if (el.type !== 'checkbox') return;
      if (!el.checked) return;

      enforceSingleSelect(el);
    },
    true
  );
})();
